// extracted by mini-css-extract-plugin
module.exports = {"option":"SelectDeskName_option__32m4u"};